import { FC } from "react";
import { GlobeEuropeAfricaIcon } from "@heroicons/react/24/outline";
import { StatusBadge, Toggle } from "../ui";

interface Props {
  isActive: boolean;
  onToggle: (isEnabled: boolean) => void;
}

export const NaturvardsverketReportingSection: FC<Props> = ({
  isActive,
  onToggle,
}) => {
  return (
    <div className="flex items-start justify-between gap-4 rounded-xl border border-blue-100 bg-blue-50/50 p-4">
      <div className="flex items-start gap-3.5">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-blue-700 ring-1 ring-inset ring-blue-100">
          <GlobeEuropeAfricaIcon className="h-5 w-5" />
        </span>
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-sm font-semibold text-slate-900">
              Rapportering till Naturvårdsverket
            </p>
            <StatusBadge color={isActive ? "green" : "slate"} dot>
              {isActive ? "Aktiverad" : "Inaktiverad"}
            </StatusBadge>
          </div>
          <p className="mt-1 max-w-prose text-sm text-slate-500">
            {isActive
              ? "Avfall rapporteras till Naturvårdsverkets avfallsregister."
              : "Aktivera för att rapportera avfall till avfallsregistret."}
          </p>
        </div>
      </div>
      <div className="shrink-0 pt-0.5">
        <Toggle isEnabled={isActive} onChange={onToggle} />
      </div>
    </div>
  );
};
